<template>
  <v-container
    fluid
    class="pa-0 ma-0"
    style="height: 80vh; display: flex; flex-direction: column;"
  >
    <div class="mapa-body">
      <div
        class="mapa-sidebar"
        :style="{ width: sidebarWidth + 'px' }"
      >
        <div class="mapa-sidebar__search">
          <v-text-field
            v-model="busca"
            dense
            outlined
            hide-details
            placeholder="Buscar entrega..."
            prepend-inner-icon="mdi-magnify"
            class="mapa-sidebar__input"
          />
        </div>

        <div
          v-if="carregando && tableEntrega.length === 0"
          class="mapa-sidebar__loading"
        >
          <v-icon
            class="mapa-spinner mr-2"
            :style="{ color: corPrimaria }"
          >
            mdi-cached
          </v-icon>
          Carregando...
        </div>

        <div class="mapa-sidebar__lista">
          <div
            v-for="item in entregasFiltradas"
            :key="item.romaneioId"
            class="mapa-driver-card"
            :class="{ 'mapa-driver-card--selecionado': entregaSelecionada === item.romaneioId }"
            @click="onClickMapaEntrega(item.listaRomaenio, item.enderecoEmpresa, item.romaneioId, item.latitudeInicio, item.longitudeInicio)"
          >
            <div
              class="mapa-driver-card__avatar"
              :style="{ background: getAvatarBg(item.status), color: getStatusRomaneioColor(item.status) }"
            >
              {{ item.romaneioId }}
            </div>

            <div class="mapa-driver-card__info">
              <div class="mapa-driver-card__header">
                <div class="mapa-driver-card__nome">
                  {{ item.motorista }}
                </div>
                <div
                  class="mapa-driver-card__status-dot"
                  :style="{ background: getStatusRomaneioColor(item.status) }"
                />
                <v-icon
                  small
                  class="ml-1 mapa-driver-card__expand-icon"
                >
                  {{ entregaAberta === item.romaneioId ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>

              <div class="mapa-driver-card__sub">
                {{ item.transportadora }}
              </div>

              <div class="mapa-driver-card__badges">
                <span class="mapa-driver-card__data">
                  <v-icon
                    x-small
                    class="mr-1"
                    color="#aaa"
                  >mdi-clock-outline</v-icon>{{ item.dataStatus }}
                </span>
                <span
                  class="mapa-badge"
                  :style="{ background: getAvatarBg(item.status), color: getStatusRomaneioColor(item.status) }"
                >
                  {{ item.status }}
                </span>
              </div>

              <transition name="slide-down">
                <div
                  v-if="entregaAberta === item.romaneioId"
                  class="mapa-driver-card__notas"
                  @click.stop
                >
                  <div class="mapa-notas-header">
                    <v-icon
                      x-small
                      class="mr-1"
                    >
                      mdi-file-document-outline
                    </v-icon>
                    {{ item.listaRomaenio.length }} nota(s)
                  </div>

                  <div
                    v-for="(nota, index) in item.listaRomaenio"
                    :key="nota.idListaRomaneio"
                    class="mapa-nota-card"
                    @click="abrirHistoricoStatus(nota)"
                  >
                    <div class="mapa-nota-card__left">
                      <div class="nota-titulo">
                        NF {{ nota.numeroNota }}
                      </div>
                     <div class="nota-ordem">
                      <v-icon
                        x-small
                        class="mr-1"
                      >
                        mdi-format-list-numbered
                      </v-icon>
                      Ordem {{ index + 1 }}
                    </div>
                      <div class="nota-cliente">
                        {{ nota.nomeCliente }}
                      </div>
                      <div
                        v-if="nota.responsavelRecebimento && nota.responsavelRecebimento !== 'Não Informado'"
                        class="nota-responsavel"
                      >
                        <v-icon
                          x-small
                          class="mr-1"
                        >
                          mdi-account-check
                        </v-icon>{{ nota.responsavelRecebimento }}
                      </div>
                      <div
                        v-if="nota.dataEntrega"
                        class="nota-data"
                      >
                        <v-icon
                          x-small
                          class="mr-1"
                        >
                          mdi-calendar-check
                        </v-icon>{{ nota.dataEntrega }}
                      </div>
                    </div>
                    <div class="mapa-nota-card__right">
                      <span
                        class="nota-status-badge"
                        :style="{ background: getAvatarBg(nota.statusEntrega), color: getColorByStatus(nota.statusEntrega) }"
                      >
                        {{ nota.statusEntrega }}
                      </span>
                      <v-icon
                        x-small
                        class="nota-hist-icon"
                        title="Ver histórico"
                      >
                        mdi-history
                      </v-icon>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <div
            v-if="!carregando && tableEntrega.length === 0"
            class="mapa-sidebar__vazio"
          >
            Nenhuma entrega encontrada nesse período.
          </div>
        </div>
      </div>

      <div
        class="mapa-resizer"
        @mousedown="startResize"
      />

      <div class="mapa-area">
        <div
          v-if="legendaRota.length > 0"
          class="mapa-legenda"
        >
          <div
            v-for="(legenda, i) in legendaRota"
            :key="i"
            class="mapa-legenda__item"
          >
            <span
              class="mapa-legenda__dot"
              :style="{ background: legenda.color || legenda.cor }"
            />
            <span class="mapa-legenda__label">{{ legenda.status }}</span>
          </div>
        </div>
        <div
          id="map"
          class="mapa-canvas"
        />
      </div>
    </div>

    <!-- Dialog: Histórico de Status da Nota -->
    <v-dialog
      v-model="dialog.visible"
      transition="dialog-bottom-transition"
      persistent
      max-width="700px"
      @keydown.esc="dialog.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          <h4>{{ dialog.message }}</h4>
        </v-card-text>
        <v-card-text class="pb-5 pt-1">
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="border: 1px solid #e0e0e0; padding: 10px; background-color: #f5f5f5; text-align: center;">
                  #
                </th>
                <th style="border: 1px solid #e0e0e0; padding: 10px; background-color: #f5f5f5; text-align: center;">
                  Data
                </th>
                <th style="border: 1px solid #e0e0e0; padding: 10px; background-color: #f5f5f5; text-align: left;">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(hist, index) in dialog.historico"
                :key="index"
              >
                <td style="border: 1px solid #e0e0e0; padding: 8px; text-align: center;">
                  {{ index + 1 }}
                </td>
                <td style="border: 1px solid #e0e0e0; padding: 8px; text-align: center;">
                  {{ hist.data }}
                </td>
                <td style="border: 1px solid #e0e0e0; padding: 8px; text-align: left;">
                  {{ hist.status }}
                </td>
              </tr>
              <tr v-if="!dialog.historico || dialog.historico.length === 0">
                <td
                  colspan="3"
                  style="text-align: center; padding: 16px; color: #9e9e9e;"
                >
                  Nenhum histórico encontrado.
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Entrega from '../../../../services/entrega'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    emits: ['exibirDadosOrdenacaoEntrega'],

    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data () {
      return {
        map: null,
        corPrimaria: localStorage.corPrimaria || '#1976D2',
        center: {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        },
        primeiroDia: '',
        dataFinal: '',
        dataInicialStatus: '',
        dataFinalStatus: '',
        select: [],
        motorista: [],
        statusEntrega: [],
        selectOpcaoOrdenacao: [],
        selectOrientacaoOrdem: [],
        tableEntrega: [],
        tableDetalheEntrega: [],
        locations: [],
        corsLegend: [
          { corBackground: '#ea4335', corGlyph: '#b31412' },
          { corBackground: '#64B5F6', corGlyph: '#FFFFFF' },
          { corBackground: '#64B5F6', corGlyph: '#2196F3' },
          { corBackground: '#8D6E63', corGlyph: '#795548' },
          { corBackground: '#26A69A', corGlyph: '#009688' },
          { corBackground: '#C8E6C9', corGlyph: '#4CAF50' },
          { corBackground: '#FFF176', corGlyph: '#FBC02D' },
          { corBackground: '#FFB74D', corGlyph: '#FF9800' },
          { corBackground: '#EEEEEE', corGlyph: '#9E9E9E' },
          { corBackground: '#BA68C8', corGlyph: '#9C27B0' },
        ],
        loading: false,
        loadingMaps: false,
        loadingTableDetalhe: false,
        enableTableDetalhe: false,
        error: null,
        enableMaps: false,
        idRomaneio: null,
        selectOrdem: { id: 1, nomeExibicao: 'Ordem Magis Ti' },
        legendaRota: [],
        listaAuxExibicao: [],
        enderecoAux: '',
        enableSelect: false,
        ordenacao: '',
        ordenacaoDecrescente: false,
        ordenacaoNotas: '',
        ordenacaoDecrescenteNotas: false,
        snackbar: {
          visible: false,
          color: 'success',
          direction: 'top center',
          message: '',
          timeout: 3000,
        },
        dialog: {
          visible: false,
          message: '',
          historico: [],
        },
        latitudeInicioAux: null,
        longitudeInicioAux: null,
        carregando: false,
        entregaAberta: null,
        sidebarWidth: 360,
        resizing: false,
        startX: 0,
        startWidth: 0,
        entregaSelecionada: null,
        busca: '',
      }
    },

    computed: {
      entregasFiltradas () {
        if (!this.busca || !this.busca.trim()) return this.tableEntrega
        const termo = this.busca.trim().toLowerCase()
        return this.tableEntrega.filter(item =>
          String(item.romaneioId).toLowerCase().includes(termo) ||
          (item.motorista || '').toLowerCase().includes(termo) ||
          (item.transportadora || '').toLowerCase().includes(termo) ||
          (item.status || '').toLowerCase().includes(termo),
        )
      },
    },

    created () {
      eventEmit.$on('update-form-magis-entrega', this.handleUpdateDados)
      eventEmit.$on('ordenar-dados-entrega', this.handleOrdenarEntrega)
      eventEmit.$on('ordenar-dados', this.handleAlterarOrdemExibicao)
      eventEmit.$on('updateDadosTabela', this.handleAlterarOrdemExibicao)
    },

    mounted () {
      this.iniciarMapa()
    },

    beforeDestroy () {
      eventEmit.$off('update-form-magis-entrega', this.handleUpdateDados)
      eventEmit.$off('ordenar-dados-entrega', this.handleOrdenarEntrega)
      eventEmit.$off('ordenar-dados', this.handleAlterarOrdemExibicao)
      eventEmit.$off('updateDadosTabela', this.handleAlterarOrdemExibicao)
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.stopResize)
    },

    methods: {
      // ─── Sidebar Resize ───────────────────────────────────────────────
      startResize (e) {
        this.resizing = true
        this.startX = e.clientX
        this.startWidth = this.sidebarWidth
        document.addEventListener('mousemove', this.onResize)
        document.addEventListener('mouseup', this.stopResize)
      },

      onResize (e) {
        if (!this.resizing) return
        const newWidth = this.startWidth + (e.clientX - this.startX)
        if (newWidth >= 200 && newWidth <= 600) {
          this.sidebarWidth = newWidth
        }
      },

      stopResize () {
        this.resizing = false
        document.removeEventListener('mousemove', this.onResize)
        document.removeEventListener('mouseup', this.stopResize)
        this.$nextTick(() => {
          if (this.map) {
            window.google.maps.event.trigger(this.map, 'resize')
            this.map.setCenter(this.center)
          }
        })
      },

      // ─── Helpers de cor / avatar ──────────────────────────────────────
      hexToRgba (hex, opacity) {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
      },

      getAvatarBg (status) {
        return this.hexToRgba(this.getStatusRomaneioColor(status), 0.15)
      },

      getStatusRomaneioColor (status) {
        switch (String(status || '').toLowerCase()) {
          case 'rota': return '#FFA500'
          case 'pausado': return '#FF8A80'
          case 'aberto': return '#9E9E9E'
          case 'finalizado': return '#1D9E75'
          default: return '#1976D2'
        }
      },

      getColorByStatus (statusEntrega) {
        switch (statusEntrega) {
          case 'Entregue': return '#2E7D32'
          case 'Aberto': return '#9E9E9E'
          case 'Rota': return '#FFEB3B'
          case 'Endereço fechado': return '#F9A825'
          case 'Endereço errado': return '#795548'
          case 'Endereço não localizado': return '#7B1FA2'
          default: return '#D32F2F'
        }
      },

      // ─── Eventos de filtro externos ───────────────────────────────────
      handleUpdateDados (primeiroDia, dataFinal, dataInicialStatus, dataFinalStatus, motorista, statusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.dataInicialStatus = dataInicialStatus
        this.dataFinalStatus = dataFinalStatus
        this.motorista = motorista
        this.statusEntrega = statusEntrega
        this.selectOrdem = selectOrdem
        this.selectOpcaoOrdenacao = selectOpcaoOrdenacao
        this.selectOrientacaoOrdem = selectOrientacaoOrdem
        this.atualizaTable()
      },

      handleOrdenarEntrega (selectOrdem) {
        this.selectOrdem = selectOrdem
        this.filtrarOrdemEntrega()
      },

      handleAlterarOrdemExibicao (orientacao, selectOpcaoOrdenacao) {
        this.selectOpcaoOrdenacao = selectOpcaoOrdenacao
        this.ordenarTabela(orientacao)
      },

      // ─── Mapa inicial ─────────────────────────────────────────────────
      async iniciarMapa () {
        await this.$nextTick()
        const center = { lat: -20.7523412, lng: -42.8732878 }
        this.map = new window.google.maps.Map(document.getElementById('map'), {
          center,
          zoom: 13,
          mapId: '6ae34073275a94e4',
          zoomControl: true,
          streetViewControl: true,
          mapTypeControl: false,
          fullscreenControl: true,
        })
        this.center = center
      },

      // ─── Carregamento de dados ────────────────────────────────────────
      async atualizaTable () {
        this.carregando = true
        this.loading = true
        this.enableMaps = false
        this.enableTableDetalhe = false
        this.tableEntrega = []
        this.idRomaneio = ''
        this.legendaRota = []
        this.ordenacao = ''
        this.ordenacaoDecrescente = false
        this.ordenacaoNotas = ''
        this.ordenacaoDecrescenteNotas = false

        await Entrega.showDadosEntrega(
          this.primeiroDia, this.dataFinal, this.select,
          localStorage.tokencontrato,
          this.dataInicialStatus, this.dataFinalStatus,
          this.motorista, this.statusEntrega,
          this.selectOpcaoOrdenacao, this.selectOrientacaoOrdem,
        ).then(resposta => {
          if (resposta.data.status) {
            this.tableEntrega = resposta.data.dados.map(item => ({
              romaneioId: item.idRomaneio,
              data: item.dataRomaneio,
              status: item.statusEntrega,
              dataStatus: item.dataStatus,
              motorista: item.nomeMotorista,
              transportadora: item.nomeTransportador,
              enderecoEmpresa: item.enderecoEmpresa,
              latitudeInicio: item.latitudeInicio,
              longitudeInicio: item.longitudeInicio,
              listaRomaenio: this.getListaRomaneio(item.listaRomaneio),
            }))
          }
        }).catch(e => {
          const msg = e.message === 'Network Error' ? 'Falha na conexão com a internet' : (e.data?.msg || 'Erro desconhecido')
          this.error = msg
          this.showSnackbar('error', 3000, msg)
        }).finally(() => {
          this.loading = false
          this.carregando = false
          this.ordenacao = 'romaneioId'
          eventEmit.$emit('exibir-dados-ordenacao-entrega', this.tableEntrega.length > 0)
        })
      },

      getListaRomaneio (listaRomaneio) {
        return listaRomaneio.map(item => ({
          idListaRomaneio: item.idListaRomaneio,
          idNotaFiscal: item.idNotaFiscal,
          numeroNota: item.numeroNota,
          nomeCliente: item.nomeCliente,
          latitude: item.latitude,
          longitude: item.longitude,
          latitudeCheckin: item.latitudeCheckin,
          longitudeCheckin: item.longitudeCheckin,
          statusEntrega: item.statusEntrega,
          dataEntrega: item.dataEntrega !== '30/12/1899' ? item.dataEntregaExibicao : '',
          enderecoEntrega: item.enderecoEntrega,
          enderecoCliente: item.enderecoCliente,
          idLegenda: item.idLegenda,
          ordemEntrega: item.ordemEntrega,
          responsavelRecebimento: item.responsavelRecebimento === 'null' ? 'Não Informado' : item.responsavelRecebimento,
          hist: item.hist ? item.hist.map(h => ({ data: h.data, status: h.status })) : [],
        }))
      },

      // ─── Clique na entrega: trava de mapa ────────────────────────────
      async onClickMapaEntrega (lista, enderecoEmpresa, romaneioId, latitudeInicio, longitudeInicio) {
        // Abre/fecha o painel de notas independentemente
        this.entregaAberta = this.entregaAberta === romaneioId ? null : romaneioId
        this.entregaSelecionada = romaneioId

        // TRAVA: se já é a entrega selecionada e o mapa está carregado, não recarrega
        if (this.idRomaneio === romaneioId && this.enableMaps) {
          return
        }

        try {
          this.ordenacaoNotas = ''
          this.ordenacaoDecrescenteNotas = false
          this.enableSelect = true
          this.idRomaneio = romaneioId
          this.loadingMaps = true
          this.enableMaps = false
          this.legendaRota = []
          this.listaAuxExibicao = lista
          this.enderecoAux = enderecoEmpresa
          this.latitudeInicioAux = latitudeInicio
          this.longitudeInicioAux = longitudeInicio

          await new Promise(resolve => setTimeout(resolve, 500))

          this.$nextTick(() => { this.enableMaps = true })

          let count = 0
          setTimeout(() => {
            this.locations = lista.map(item => {
              count++
              return {
                lat: item.latitude,
                lng: item.longitude,
                enderecoEntrega: item.enderecoEntrega !== '' ? item.enderecoEmpresa : item.enderecoCliente,
                ordemEntrega: item.ordemEntrega,
                ordemEntregaExibicao: item.ordemEntrega,
                dataEntrega: item.dataEntrega,
                tooltip: `${count} - ${item.numeroNota}` +
                  (item.dataEntrega ? ` - ${item.dataEntrega}` : '') +
                  (item.responsavelRecebimento ? ` (${item.responsavelRecebimento})` : ''),
                corBackground: this.getColorByStatus(item.statusEntrega),
                corGlyph: this.corsLegend[1].corGlyph,
                statusEntrega: item.statusEntrega,
              }
            })
            this.center = this.locations[0]
          }, 1000)
        } finally {
          this.loadingMaps = false
          this.filtrarOrdemEntrega()
        }
      },

      // ─── Marcadores e rotas no mapa ───────────────────────────────────
      setMarker (enderecoOrigem, longitudeInicioAux, latitudeInicioAux, pontosMotorista = []) {
        this.legendaRota = []

        const geocoder = new window.google.maps.Geocoder()
        const infoWindow = new window.google.maps.InfoWindow()
        const directionsService = new window.google.maps.DirectionsService()

        const geocodeLocation = (location) => {
          return new Promise((resolve) => {
            if (location.lat && location.lng) {
              resolve(location)
            } else {
              geocoder.geocode({ address: location.enderecoEntrega }, (results, status) => {
                if (status === 'OK' && results[0]) {
                  location.lat = results[0].geometry.location.lat()
                  location.lng = results[0].geometry.location.lng()
                }
                resolve(location)
              })
            }
          })
        }

        Promise.all(this.locations.map(geocodeLocation)).then((locationsWithCoords) => {
          const orderedLocations = locationsWithCoords
            .filter(loc => loc.lat && loc.lng)
            .sort((a, b) => a.ordemEntrega - b.ordemEntrega)

          if (orderedLocations.length === 0) {
            this.enableMaps = false
            return
          }

          const map = new window.google.maps.Map(document.getElementById('map'), {
            center: orderedLocations[0],
            zoom: 12,
            mapId: '6ae34073275a94e4',
          })

          map.setCenter({ lat: orderedLocations[0].lat, lng: orderedLocations[0].lng })

          geocoder.geocode({ address: enderecoOrigem }, (results, status) => {
            let empresaLocation = null

            if (status === 'OK' && results[0]) {
              empresaLocation = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
              }
            }

            if (latitudeInicioAux && longitudeInicioAux) {
              empresaLocation = {
                lat: Number(latitudeInicioAux),
                lng: Number(longitudeInicioAux),
              }
            }

            if (!empresaLocation) {
              console.error('Não foi possível determinar o ponto de início.')
              return
            }

            const flagSVG = `
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                <rect x="2" y="2" width="2" height="28" fill="black"/>
                <rect x="4" y="2" width="6" height="6" fill="black"/>
                <rect x="10" y="2" width="6" height="6" fill="white"/>
                <rect x="16" y="2" width="6" height="6" fill="black"/>
                <rect x="4" y="8" width="6" height="6" fill="white"/>
                <rect x="10" y="8" width="6" height="6" fill="black"/>
                <rect x="16" y="8" width="6" height="6" fill="white"/>
                <rect x="4" y="14" width="6" height="6" fill="black"/>
                <rect x="10" y="14" width="6" height="6" fill="white"/>
                <rect x="16" y="14" width="6" height="6" fill="black"/>
                <rect x="4" y="20" width="6" height="6" fill="white"/>
                <rect x="10" y="20" width="6" height="6" fill="black"/>
                <rect x="16" y="20" width="6" height="6" fill="white"/>
              </svg>
            `

            // eslint-disable-next-line no-new
            new window.google.maps.Marker({
              position: empresaLocation,
              map,
              title: 'Ponto de Partida',
              icon: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(flagSVG),
                scaledSize: new window.google.maps.Size(32, 32),
                anchor: new window.google.maps.Point(16, 32),
              },
            })

            orderedLocations.forEach(location => {
              const pinView = new window.google.maps.marker.PinView({
                background: this.getColorByStatus(location.statusEntrega),
                glyphColor: location.corGlyph,
                borderColor: location.corBackground,
                glyphText: String(location.ordemEntrega),
              })

              const marker = new window.google.maps.marker.AdvancedMarkerElement({
                position: { lat: location.lat, lng: location.lng },
                map,
                title: location.tooltip,
                content: pinView.element,
              })

              marker.addListener('gmp-click', () => {
                infoWindow.close()
                infoWindow.setContent(marker.title)
                infoWindow.open(marker.map, marker)
              })
            })

            const drawSegment = (start, end, color) => {
              directionsService.route(
                { origin: start, destination: end, travelMode: window.google.maps.TravelMode.DRIVING },
                (result, status) => {
                  if (status === 'OK') {
                    // eslint-disable-next-line no-new
                    new window.google.maps.DirectionsRenderer({
                      map,
                      directions: result,
                      suppressMarkers: true,
                      polylineOptions: { strokeColor: color, strokeWeight: 5, strokeOpacity: 0.8 },
                    })
                  }
                },
              )
            }

            if (!this.selectOrdem || this.selectOrdem.id !== 2) {
              let previousPoint = { lat: empresaLocation.lat, lng: empresaLocation.lng }

              orderedLocations.forEach(location => {
                const color = this.getColorByStatus(location.statusEntrega)
                if (!this.legendaRota.some(item => item.status === location.statusEntrega)) {
                  this.legendaRota.push({ status: location.statusEntrega, color })
                }
                drawSegment(previousPoint, { lat: location.lat, lng: location.lng }, color)
                previousPoint = { lat: location.lat, lng: location.lng }
              })
            } else {
              orderedLocations.forEach(location => {
                const color = this.getColorByStatus(location.statusEntrega)
                if (!this.legendaRota.some(item => item.status === location.statusEntrega)) {
                  this.legendaRota.push({ status: location.statusEntrega, cor: color })
                }
              })

              if (pontosMotorista.length >= 2) {
                const totalSegmentos = pontosMotorista.length - 1
                const totalLocations = orderedLocations.length

                for (let i = 0; i < totalSegmentos; i++) {
                  const locationIndex = Math.min(Math.floor((i / totalSegmentos) * totalLocations), totalLocations - 1)
                  const color = this.getColorByStatus(orderedLocations[locationIndex].statusEntrega)

                  new window.google.maps.Polyline({
                    path: [pontosMotorista[i], pontosMotorista[i + 1]],
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: 0.9,
                    strokeWeight: 4,
                  }).setMap(map)
                }
              } else {
                let previousPoint = { lat: empresaLocation.lat, lng: empresaLocation.lng }

                orderedLocations.forEach(location => {
                  const color = this.getColorByStatus(location.statusEntrega)
                  drawSegment(previousPoint, { lat: location.lat, lng: location.lng }, color)
                  previousPoint = { lat: location.lat, lng: location.lng }
                })
              }
            }
          })
        })
      },

      // ─── Tabela de detalhe (notas) ────────────────────────────────────
      montarTableDetalhe (lista) {
        try {
          this.loadingTableDetalhe = true
          let i = 1
          this.tableDetalheEntrega = lista.map(item => ({
            ordem: i++,
            nomeCliente: item.nomeCliente,
            numeroNota: item.numeroNota,
            responsavelRecebimento: item.responsavelRecebimento,
            statusEntrega: item.statusEntrega,
            dataEntrega: item.dataEntrega,
            hist: item.hist || [],
          }))
        } catch {
          this.error = 'Erro ao montar tabela de detalhes'
        } finally {
          this.enableTableDetalhe = this.tableDetalheEntrega.length > 0
          if (!this.enableTableDetalhe) this.enableMaps = false
          this.loadingTableDetalhe = false
        }
      },

      abrirHistoricoStatus (item) {
        this.dialog.message = `Histórico de Status — NF ${item.numeroNota}`
        this.dialog.historico = item.hist || []
        this.dialog.visible = true
      },

      async buscarLocalizacaoMotorista (romaneioId) {
        try {
          const resposta = await Entrega.showLocalizacaoMotorista(localStorage.tokencontrato, romaneioId)
          if (resposta.data.success && resposta.data.data.length > 0) {
            return resposta.data.data.map(item => ({
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            }))
          }
          return []
        } catch (error) {
          console.error('Erro ao buscar localização do motorista:', error)
          return []
        }
      },

      // ─── Filtragem / ordenação de ordem de entrega ────────────────────
      // async filtrarOrdemEntrega () {
      //   try {
      //     this.enableTableDetalhe = false
      //     this.tableDetalheEntrega = []
      //     this.ordenacaoNotas = ''
      //     this.ordenacaoDecrescenteNotas = false
      //     this.enableMaps = false

      //     const parseDate = (str) => {
      //       if (!str || str.trim() === '') return null
      //       const [data, hora] = str.split(' ')
      //       const [dia, mes, ano] = data.split('/').map(Number)
      //       const [h, m, s] = hora ? hora.split(':').map(Number) : [0, 0, 0]
      //       return new Date(ano, mes - 1, dia, h, m, s)
      //     }

      //     const compareDates = (a, b) => {
      //       const dateA = parseDate(a.dataEntrega)
      //       const dateB = parseDate(b.dataEntrega)
      //       if (!dateA && !dateB) return 0
      //       if (!dateA) return 1
      //       if (!dateB) return -1
      //       return dateA - dateB
      //     }

      //     if (this.selectOrdem && this.selectOrdem.id === 2) {
      //       const tableOrdenadaDataDados = this.listaAuxExibicao.sort((a, b) => {
      //         const dateA = parseDate(a.dataEntrega)
      //         const dateB = parseDate(b.dataEntrega)

      //         if (!dateA && !dateB) return 0

      //         if (!dateA) return 1

      //         if (!dateB) return -1

      //         return dateA - dateB
      //       })

      //       const tableOrdenadaData = this.listaAuxExibicao
      //         .filter(item => item.dataEntrega && item.dataEntrega.trim() !== '' && !item.dataEntrega.includes('1899'))
      //         .sort(compareDates)

      //       let count = 0
      //       this.locations = tableOrdenadaData.map(item => {
      //         count++
      //         return {
      //           lat: item.latitudeCheckin ?? item.latitude,
      //           lng: item.longitudeCheckin ?? item.longitude,
      //           enderecoEntrega: item.enderecoEntrega !== '' ? item.enderecoEmpresa : item.enderecoCliente,
      //           ordemEntrega: count,
      //           ordemEntregaExibicao: count,
      //           dataEntrega: item.dataEntrega,
      //           statusEntrega: item.statusEntrega,
      //           tooltip: `${count} - ${item.numeroNota}` +
      //             (item.dataEntrega ? ` - ${item.dataEntrega}` : '') +
      //             (item.responsavelRecebimento ? ` (${item.responsavelRecebimento})` : ''),
      //           corBackground: this.corsLegend[1].corBackground,
      //           corGlyph: this.corsLegend[1].corGlyph,
      //         }
      //       })

      //       // Deslocar marcadores sobrepostos
      //       const coordCount = {}
      //       this.locations = this.locations.map(loc => {
      //         const key = `${loc.lat},${loc.lng}`
      //         if (!coordCount[key]) coordCount[key] = 0
      //         const index = coordCount[key]++
      //         if (index === 0) return loc
      //         const angulo = (index * 137.5 * Math.PI) / 180
      //         const raio = 0.00010 * Math.ceil(index / 8)
      //         return { ...loc, lat: loc.lat + raio * Math.cos(angulo), lng: loc.lng + raio * Math.sin(angulo) }
      //       })

      //       const pontosMotorista = await this.buscarLocalizacaoMotorista(this.idRomaneio)

      //       this.$nextTick(() => {
      //         this.enableMaps = true
      //         this.setMarker(this.enderecoAux, this.longitudeInicioAux, this.latitudeInicioAux, pontosMotorista)
      //       })

      //       this.montarTableDetalhe(tableOrdenadaDataDados)
      //     } else {
      //       const tableOrdenada = [...this.listaAuxExibicao].sort((a, b) => a.ordemEntrega - b.ordemEntrega)

      //       let count = 0
      //       this.locations = tableOrdenada.map(item => {
      //         count++
      //         return {
      //           lat: item.latitude,
      //           lng: item.longitude,
      //           enderecoEntrega: item.enderecoEntrega !== '' ? item.enderecoEmpresa : item.enderecoCliente,
      //           ordemEntrega: item.ordemEntrega,
      //           ordemEntregaExibicao: item.ordemEntrega,
      //           dataEntrega: item.dataEntrega,
      //           statusEntrega: item.statusEntrega,
      //           tooltip: `${count} - ${item.numeroNota}` +
      //             (item.dataEntrega ? ` - ${item.dataEntrega}` : '') +
      //             (item.responsavelRecebimento ? ` (${item.responsavelRecebimento})` : ''),
      //           corBackground: this.corsLegend[1].corBackground,
      //           corGlyph: this.corsLegend[1].corGlyph,
      //         }
      //       })

      //       this.$nextTick(() => {
      //         this.enableMaps = true
      //         this.setMarker(this.enderecoAux, this.longitudeInicioAux, this.latitudeInicioAux, [])
      //       })

      //       this.montarTableDetalhe(tableOrdenada)
      //     }
      //   } catch (error) {
      //     console.error('Erro ao filtrar ordem de entrega:', error)
      //   }
      // },
      async filtrarOrdemEntrega () {
        try {
          this.enableTableDetalhe = false
          this.tableDetalheEntrega = []
          this.ordenacaoNotas = ''
          this.ordenacaoDecrescenteNotas = false
          this.enableMaps = false

          const parseDate = (str) => {
            if (!str || str.trim() === '') return null

            const [data, hora] = str.split(' ')
            const [dia, mes, ano] = data.split('/').map(Number)
            const [h, m, s] = hora ? hora.split(':').map(Number) : [0, 0, 0]

            return new Date(ano, mes - 1, dia, h, m, s)
          }

          const compareDates = (a, b) => {
            const dateA = parseDate(a.dataEntrega)
            const dateB = parseDate(b.dataEntrega)

            if (!dateA && !dateB) return 0
            if (!dateA) return 1
            if (!dateB) return -1

            return dateA - dateB
          }

          if (this.selectOrdem && this.selectOrdem.id === 2) {
            const tableOrdenadaDataDados = [...this.listaAuxExibicao].sort(compareDates)

            // Atualiza a lista exibida na sidebar
            this.listaAuxExibicao = tableOrdenadaDataDados

            const entrega = this.tableEntrega.find(
              item => item.romaneioId === this.idRomaneio,
            )

            if (entrega) {
              entrega.listaRomaenio = [...tableOrdenadaDataDados]
            }

            const tableOrdenadaData = tableOrdenadaDataDados.filter(item =>
              item.dataEntrega &&
              item.dataEntrega.trim() !== '' &&
              !item.dataEntrega.includes('1899'),
            )

            let count = 0

            this.locations = tableOrdenadaData.map(item => {
              count++

              return {
                lat: item.latitudeCheckin ?? item.latitude,
                lng: item.longitudeCheckin ?? item.longitude,
                enderecoEntrega: item.enderecoEntrega !== '' ? item.enderecoEmpresa : item.enderecoCliente,
                ordemEntrega: count,
                ordemEntregaExibicao: count,
                dataEntrega: item.dataEntrega,
                statusEntrega: item.statusEntrega,
                tooltip: `${count} - ${item.numeroNota}` +
                  (item.dataEntrega ? ` - ${item.dataEntrega}` : '') +
                  (item.responsavelRecebimento ? ` (${item.responsavelRecebimento})` : ''),
                corBackground: this.corsLegend[1].corBackground,
                corGlyph: this.corsLegend[1].corGlyph,
              }
            })

            const coordCount = {}

            this.locations = this.locations.map(loc => {
              const key = `${loc.lat},${loc.lng}`

              if (!coordCount[key]) coordCount[key] = 0

              const index = coordCount[key]++

              if (index === 0) return loc

              const angulo = (index * 137.5 * Math.PI) / 180
              const raio = 0.00010 * Math.ceil(index / 8)

              return {
                ...loc,
                lat: loc.lat + raio * Math.cos(angulo),
                lng: loc.lng + raio * Math.sin(angulo),
              }
            })

            const pontosMotorista = await this.buscarLocalizacaoMotorista(this.idRomaneio)

            this.$nextTick(() => {
              this.enableMaps = true

              this.setMarker(
                this.enderecoAux,
                this.longitudeInicioAux,
                this.latitudeInicioAux,
                pontosMotorista,
              )
            })

            this.montarTableDetalhe(tableOrdenadaDataDados)
          } else {
            const tableOrdenada = [...this.listaAuxExibicao].sort(
              (a, b) => a.ordemEntrega - b.ordemEntrega,
            )

            // Atualiza a lista exibida na sidebar
            this.listaAuxExibicao = tableOrdenada

            const entrega = this.tableEntrega.find(
              item => item.romaneioId === this.idRomaneio,
            )

            if (entrega) {
              entrega.listaRomaenio = [...tableOrdenada]
            }

            let count = 0

            this.locations = tableOrdenada.map(item => {
              count++

              return {
                lat: item.latitude,
                lng: item.longitude,
                enderecoEntrega: item.enderecoEntrega !== '' ? item.enderecoEmpresa : item.enderecoCliente,
                ordemEntrega: item.ordemEntrega,
                ordemEntregaExibicao: item.ordemEntrega,
                dataEntrega: item.dataEntrega,
                statusEntrega: item.statusEntrega,
                tooltip: `${count} - ${item.numeroNota}` +
                  (item.dataEntrega ? ` - ${item.dataEntrega}` : '') +
                  (item.responsavelRecebimento ? ` (${item.responsavelRecebimento})` : ''),
                corBackground: this.corsLegend[1].corBackground,
                corGlyph: this.corsLegend[1].corGlyph,
              }
            })

            this.$nextTick(() => {
              this.enableMaps = true

              this.setMarker(
                this.enderecoAux,
                this.longitudeInicioAux,
                this.latitudeInicioAux,
                [],
              )
            })

            this.montarTableDetalhe(tableOrdenada)
          }
        } catch (error) {
          console.error('Erro ao filtrar ordem de entrega:', error)
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
/* ─── Layout principal ──────────────────────────────────────────── */
.mapa-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.mapa-sidebar {
  min-width: 200px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0,0,0,0.08);
  background: #fafafa;
  overflow: hidden;
}

.mapa-resizer {
  width: 6px;
  cursor: col-resize;
  background: transparent;
}

.mapa-area {
  flex: 1;
  position: relative;
  overflow: hidden;
}

.mapa-canvas {
  width: 100%;
  height: 100%;
}

/* ─── Sidebar: busca e listas ───────────────────────────────────── */
.mapa-sidebar__search {
  padding: 10px 10px 8px;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}

.mapa-sidebar__lista {
  overflow-y: auto;
  flex: 1;
}

.mapa-sidebar__loading {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #888;
}

.mapa-sidebar__vazio {
  padding: 20px;
  text-align: center;
  font-size: 13px;
  color: #aaa;
}

/* ─── Card de entrega ───────────────────────────────────────────── */
.mapa-driver-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 0.5px solid rgba(0,0,0,0.05);
  transition: background 0.15s;
}

.mapa-driver-card:hover {
  background: #f0f4ff;
}

.mapa-driver-card--selecionado {
  background: #e8f0fe;
  border-left: 3px solid #1976D2;
}

.mapa-driver-card__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.mapa-driver-card__info {
  flex: 1;
  min-width: 0;
}

.mapa-driver-card__header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mapa-driver-card__nome {
  font-size: 13px;
  font-weight: 600;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.mapa-driver-card__status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mapa-driver-card__expand-icon {
  transition: transform 0.2s ease;
  color: #777;
}

.mapa-driver-card__sub {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mapa-driver-card__data {
  font-size: 10px;
  color: #aaa;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* ─── Badges de data/status ─────────────────────────────────────── */
.mapa-driver-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.mapa-badge {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 10px;
  background: #f0f0f0;
  color: #555;
}

.mapa-badge--data {
  background: #f0f0f0;
  color: #666;
}

/* ─── Painel de notas (expandido) ───────────────────────────────── */
.mapa-driver-card__notas {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
}

.mapa-notas-header {
  font-size: 10px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.mapa-nota-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 7px 9px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.07);
  cursor: pointer;
  transition: background 0.12s, box-shadow 0.12s;
}

.mapa-nota-card:hover {
  background: #f5f7ff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.mapa-nota-card__left {
  flex: 1;
  min-width: 0;
}

.mapa-nota-card__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 8px;
}

.nota-titulo {
  font-size: 12px;
  font-weight: 700;
  color: #1976D2;
}

.nota-cliente {
  font-size: 11px;
  color: #444;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.nota-responsavel {
  font-size: 10px;
  color: #777;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.nota-data {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.nota-status-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  white-space: nowrap;
}

.nota-hist-icon {
  color: #bbb;
  margin-top: 2px;
}

/* ─── Legenda do mapa ───────────────────────────────────────────── */
.mapa-legenda {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  background: rgba(255,255,255,0.93);
  border-radius: 8px;
  padding: 6px 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.15);
  font-size: 11px;
}

.mapa-legenda__item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.mapa-legenda__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mapa-legenda__label {
  color: #333;
  font-weight: 500;
}

/* ─── Dialog histórico ──────────────────────────────────────────── */
.dialog-historico__title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding: 12px 16px;
}

.dialog-historico__vazio {
  text-align: center;
  padding: 24px;
  color: #bbb;
  font-size: 13px;
}

.dialog-historico__timeline {
  display: flex;
  flex-direction: column;
}

.timeline-item {
  display: flex;
  gap: 12px;
}

.timeline-item__marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding-top: 3px;
}

.timeline-item__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1976D2;
  flex-shrink: 0;
}

.timeline-item__line {
  width: 2px;
  flex: 1;
  background: #e0e0e0;
  min-height: 20px;
  margin: 2px 0;
}

.timeline-item__content {
  padding-bottom: 14px;
  flex: 1;
}

.timeline-item__status {
  font-size: 13px;
  font-weight: 500;
  color: #222;
}

.timeline-item__data {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* ─── Animações ─────────────────────────────────────────────────── */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  max-height: 300px;
  opacity: 1;
}

.mapa-spinner {
  animation: spin 1s linear infinite;
}
.nota-ordem {
  font-size: 10px;
  color: #1976D2;
  margin-top: 2px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
